var Acr = Acr || {};

Acr.InputCard = function () {
  Acr = window.Acr || {};
  var $element;
  var $form;
  var $input;
  var $submitButton;
  var $errorMessage;
  var $inputSettings;
  var placeHoldText;
  const formInput = '.js-form-input';
  const submBtn = '.js-submit-btn';
  const inputSettings = '.js-input-settings';
  const errorMessage = '.js-error-message';

  function inputZip() {

    this.value = this.value.replace(/\D/m, '');

    if (this.value.length > 5) {
      this.value = this.value.slice(0, 5);
    }
  }

  function showError() {
    var errorMessageText = $inputSettings.data('errorMessage');
    $errorMessage.text(errorMessageText);
  }

  function clearError() {
    $errorMessage.text('');
  }

  function validZipcodeSubmit() {
    $form.submit();
  }

  function validateZipcode(e) {
    var value = $input.val();

    e.preventDefault();
    callTrackingClick();

    Utility.validateZipcode(value, validZipcodeSubmit, showError);
  }

  function initSelectors(element) {
    $element = $(element);
    $form = $(element).find('form');
    $input = $(element).find(formInput);
    $submitButton = $(element).find(submBtn);
    $inputSettings = $element.find(inputSettings);
    $errorMessage = $element.find(errorMessage);
    placeHoldText = $input.attr('placeholder');
  }

  function callTrackingClick() {
    var stringObject = $submitButton.attr('data-form-submit-tracking') ? $submitButton.attr('data-form-submit-tracking') : '';
    var clickObject = JSON.parse(stringObject.split("'").join('"'));

    if (clickObject && Acr.TrackingManager) {
      Acr.TrackingManager.clickActivity(clickObject);
    }
  }

  function inputFocus() {
    $input.attr('placeholder', '');
    clearError();
  }

  function inputBlur() {
    clearError();
    if ($input.val() === '') {
      $input.attr('placeholder', placeHoldText);
    }
  }

  function bindEvents() {
    $input.on('focus', inputFocus);
    $input.on('blur', inputBlur);
    $input.on('input', inputZip);
    $submitButton.on('click', validateZipcode);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
  }

  return {
    init: init,
  };

};
